import { Component } from '@angular/core';
import { UserPageComponent } from 'libs/shared/src/lib/page/user/user-page.component';

@Component({ standalone: false, selector: 'app-user-page', templateUrl: './user-page.component.html' })
export class CustomUserPageComponent extends UserPageComponent {}
